import { consumerRoot, isConsumer } from 'src/config'
import Model from 'src/models/model'
import { CURRENTLY_PROCESSING_GUARDS, storeLastVisitedSiteAfterGuard } from 'src/modules/consumer/guards/sharedDomainSiteSwitching'
import { buildConsumerRootRoute } from 'src/modules/consumer/routes'
import { addOrRemoveCanonicalLinkTag } from 'src/router/guards'

export default async ({ router }) => {
  if (!isConsumer) return

  await Model.configuration.ensureLoaded()

  // Update SEO related HTML tags on each navigation.
  router.beforeEach(addOrRemoveCanonicalLinkTag)
  // Store the last visited site after the most recent navigation is fully resolved.
  router.afterEach(storeLastVisitedSiteAfterGuard)
  // This after guard should go last. It resets the Set of currently processing guards.
  router.afterEach(async () => {
    await Model.ensureBooted()
    CURRENTLY_PROCESSING_GUARDS.clear()
  })

  // Assumes the currentSite at boot time matches config.siteId
  const defaultSite = Model.configuration.currentSite
  const isHostnameSharedAcrossSites = defaultSite.isHostnameSharedAcrossSites
  const sharedDomainSitesByPath = defaultSite.sharedHostnameSiteIdsByPath
  const currentHostnameParts = _.split(window.location.hostname, '.')
  const isWwwSubdomain = currentHostnameParts[0] === 'www' // e.g. "www.example.com"
  const isNakedDomain = currentHostnameParts.length <= 2 // e.g. "example.com"

  // Default site routes
  router.addRoute(buildConsumerRootRoute({
    namespace: 'consumer',
    siteId: defaultSite.id,
    siteRootPath: consumerRoot,
    isHostnameSharedAcrossSites,
    isWwwSubdomain,
    isNakedDomain
  }))

  // Shared domain site routes
  if (isHostnameSharedAcrossSites) {
    _.each(sharedDomainSitesByPath, (siteId, siteRootPath) => {
      router.addRoute(buildConsumerRootRoute({
        namespace: `consumer:site-${siteId}`,
        siteId,
        siteRootPath,
        isHostnameSharedAcrossSites
      }))
    })
  }

  if (isConsumer) {
    router.addRoute({ name: 'app:root', redirect: { name: 'consumer:root' } })
  }
}
